import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryCreditCardItems } from '../../models'

export interface IUseCreditCardItemListPresenterParams {
  accountId: number
  archived: boolean
}

export const useCreditCardItemListPresenter = ({
  accountId,
  archived,
}: IUseCreditCardItemListPresenterParams) => {
  const intl = useProcurifyIntl()

  const { items, isLoading } = useQueryCreditCardItems({
    accountId,
    archived,
    onError: (err) => {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(err) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
    },
  })

  return {
    data: {
      items,
    },
    states: {
      isLoading,
    },
  }
}
